import { Skeleton } from '../Skeleton';
import { Calendar } from '../SVGIcons/Calendar';
import { Text } from '../Text';
import styles from './news.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    title?: string; // Optional when loading
    subtitle?: string;
    description?: string;
    date?: string;
    border?: boolean;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    title: string; // Required when not loading
    subtitle?: string;
    description?: string;
    date: string;
    border?: boolean;
}

type NewsProps = LoadingProps | LoadedProps;

export const News = ({ title, subtitle, description, date, border, isLoading, ...props }: NewsProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.news, props.className)}>
                <Skeleton variant="rounded" width="82%" height={30} />
                <Skeleton variant="rounded" width="46%" height={30} />
                <Skeleton variant="rectangular" width="98%" height={24} />
                <Skeleton variant="rectangular" width="94%" height={24} />
                <Skeleton variant="rectangular" width="76%" height={18} />
                <Skeleton variant="rectangular" width="30%" height={18} />
            </div>
        );
    }

    return (
        <div {...props} className={cn(styles.news, border && styles.border, props.className)}>
            {title && (
                <Text
                    as="h2"
                    variant="h2"
                    alignment="start"
                    margin="0"
                    color="white"
                    className={styles.title}
                    size={{ default: '30', md: '48' }}
                    fontWeight="bold"
                >
                    {title}
                </Text>
            )}
            {subtitle && (
                <Text
                    as="h2"
                    variant="h2"
                    alignment="start"
                    margin="0"
                    color="white"
                    className={styles.subtitle}
                    size={{ default: '24', md: '36' }}
                    fontWeight="medium"
                >
                    {subtitle}
                </Text>
            )}
            {description && (
                <Text
                    as="p"
                    alignment="start"
                    margin="0"
                    className={styles.description}
                    size={{ default: '18', md: '22' }}
                >
                    {description}
                </Text>
            )}
            {date && (
                <div className={styles.date}>
                    <Calendar />
                    {date}
                </div>
            )}
        </div>
    );
};
